// @flow
import Table from './Table';

import Tr from './Tr';
import Th from './Th';
import Td from './Td';
import TdNum from './TdNum';
import ThNum from './ThNum';
import CollapsibleTd from './CollapsibleTd';

export default Table;

export { Tr, Th, Td, TdNum, ThNum, CollapsibleTd };



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/uikit/Table/index.js